import { mergeStoredKycUploadFlag, nextCkycVerificationFromPayload } from "helper/kycDocumentUpload";
import persistReducer from "redux-persist/lib/persistReducer";
import storage from "redux-persist/lib/storage";
import { PHCOnboardingConstants } from "./PHCOnboardingConstants";

const initialState = {
  currentStage: "",
  isOnboardingCompleted: 0,
  isPaymentCompleted: 0,
  panNumber: "",
  dateOfBirth: "",
  aadharNumber: "",
  isManualKYC: 0,
  isPanUploaded: 0,
  isAadhaarFrontUploaded: 0,
  isAadhaarBackUploaded: 0,
  panVerification: "",
  aadharFrontVerification: "",
  aadharBackVerification: "",
  duplicateStages: [],
  PHCOnboardingSteps: [
    "PORTFOLIO_UPLOAD",
    "PREVIEW",
    "GENERATE_PORTFOLIO",
    "CKYC",
    "DOCUMENT_SIGNING",
    "SAVE_REPORT",
    "ONBOARDING_COMPLETED",
  ],

  brokerRecords: 0,

  isInitialFetched: 0,
  loading: {
    onboardingData: 0,
  },
  initialCalled: {
    onboardingData: 0,
  },
  portfolioId: null,
  CKYCDone: 0,
  isBroker: null,
  isAccountHolder: null,
  consentId: null,
  redirectUrl: null,
  affiliationId: null,
};

export const PHCOnboardingReducer = persistReducer(
  {
    storage,
    key: "PHCOnboarding",
    blacklist: ["PHCOnboardingSteps", "isInitialFetched", "loading"],
  },

  (state = initialState, { type, payload }) => {
    switch (type) {
      case PHCOnboardingConstants.PHC_UPDATE_ONBOARDING_DATA: {
        return {
          ...state,
          currentStage: payload.currentStage ?? state.currentStage,
          isOnboardingCompleted:
            payload.isOnboardingCompleted ?? state.isOnboardingCompleted,
          isPaymentCompleted:
            payload.isPaymentCompleted ?? state.isPaymentCompleted,
          panNumber: payload.panNumber ?? state.panNumber,
          dateOfBirth: payload.dateOfBirth ?? state.dateOfBirth,
          aadharNumber: payload.aadharNumber ?? state.aadharNumber,
          isManualKYC: payload.isManualKYC ?? state.isManualKYC,
          isPanUploaded: mergeStoredKycUploadFlag(
            state.isPanUploaded,
            payload.isPanUploaded,
          ),
          isAadhaarFrontUploaded: mergeStoredKycUploadFlag(
            state.isAadhaarFrontUploaded,
            payload.isAadhaarFrontUploaded,
          ),
          isAadhaarBackUploaded: mergeStoredKycUploadFlag(
            state.isAadhaarBackUploaded,
            payload.isAadhaarBackUploaded,
          ),
          ...nextCkycVerificationFromPayload(state, payload),
          duplicateStages: payload.duplicateStages ?? state.duplicateStages,
          isInitialFetched: payload.isInitialFetched ?? state.isInitialFetched,
          portfolioId:
            payload.portfolioId !== undefined
              ? payload.portfolioId
              : state.portfolioId,
          CKYCDone: payload.CKYCDone ?? state.CKYCDone,
          isBroker: payload.isBroker ?? state.isBroker,
          isAccountHolder: payload.isAccountHolder ?? state.isAccountHolder,
          consentId: payload.consentId ?? state.consentId,
          redirectUrl: payload.redirectUrl ?? state.redirectUrl,
          affiliationId: payload.affiliationId ?? state.affiliationId,
        };
      }

      case PHCOnboardingConstants.PHC_ONBOARDING_DATA_REQUEST: {
        return {
          ...state,
          loading: {
            ...state.loading,
            onboardingData: 1,
          },
        };
      }

      case PHCOnboardingConstants.PHC_ONBOARDING_DATA_RESPONSE: {
        return {
          ...state,
          isInitialFetched: 1,
          currentStage: payload.currentStage ?? state.currentStage,
          isOnboardingCompleted:
            payload.isOnboardingCompleted ?? state.isOnboardingCompleted,

          isPaymentCompleted:
            payload.isPaymentCompleted ?? state.isPaymentCompleted,

          riskProfileId: payload.riskProfileId ?? state.riskProfileId,
          panNumber: payload.panNumber ?? state.panNumber,
          dateOfBirth: payload.dateOfBirth ?? state.dateOfBirth,
          aadharNumber: payload.aadharNumber ?? state.aadharNumber,
          isManualKYC: payload.isManualKYC ?? state.isManualKYC,
          isPanUploaded: mergeStoredKycUploadFlag(
            state.isPanUploaded,
            payload.isPanUploaded,
          ),
          isAadhaarFrontUploaded: mergeStoredKycUploadFlag(
            state.isAadhaarFrontUploaded,
            payload.isAadhaarFrontUploaded,
          ),
          isAadhaarBackUploaded: mergeStoredKycUploadFlag(
            state.isAadhaarBackUploaded,
            payload.isAadhaarBackUploaded,
          ),
          ...nextCkycVerificationFromPayload(state, payload),
          duplicateStages: payload.duplicateStages ?? state.duplicateStages,
          portfolioId:
            payload.portfolioId !== undefined
              ? payload.portfolioId
              : state.portfolioId,
          loading: {
            ...state.loading,
            onboardingData: 0,
          },
          CKYCDone: payload.CKYCDone ?? state.CKYCDone,
          isBroker: payload.isBroker ?? state.isBroker,
          isAccountHolder: payload.isAccountHolder ?? state.isAccountHolder,
          consentId: payload.consentId ?? state.consentId,
          redirectUrl: payload.redirectUrl ?? state.redirectUrl,
          affiliationId: payload.affiliationId ?? state.affiliationId,
        };
      }

      case PHCOnboardingConstants.PHC_RESET_ONBOARDING_DATA: {
        return {
          currentStage: "",
          isOnboardingCompleted: 0,
          panNumber: "",
          dateOfBirth: "",
          aadharNumber: "",
          isManualKYC: 0,
          isPanUploaded: 0,
          isAadhaarFrontUploaded: 0,
          isAadhaarBackUploaded: 0,
          panVerification: "",
          aadharFrontVerification: "",
          aadharBackVerification: "",
          duplicateStages: [],
          PHCOnboardingSteps: ["PAYMENT", "CKYC", "DOCUMENT_SIGNING"],
          brokerRecords: 0,

          isInitialFetched: 0,
          loading: {
            onboardingData: 0,
          },
          initialCalled: {
            onboardingData: 0,
          },
          portfolioId: "",
          CKYCDone: 0,
          isBroker: null,
          isAccountHolder: null,
          consentId: null,
          redirectUrl: null,
        };
      }

      default:
        return state;
    }
  },
);
